<template>
    <div>
        <input type="hidden" name="all-province" :value="$allProvince" />
        <input type="hidden" name="regions" :value="$regions" />
        <input type="hidden" name="counties" :value="$counties" />
        <input type="hidden" name="export-buildings" :value="$exportBuildings" />
        <input type="hidden" name="s1" :value="$s1" />
        <input type="hidden" name="s2" :value="$s2" />
        <input type="hidden" name="s3" :value="$s3" />
        <input type="hidden" name="s4" :value="$s4" />
        <input type="hidden" name="s5" :value="$s5" />
        <input type="hidden" name="s6" :value="$s6" />
        <input type="hidden" name="s7" :value="$s7" />
        <input type="hidden" name="s8" :value="$s8" />
        <input type="hidden" name="s9" :value="$s9" />
        <button type="submit" tabindex="100" class="btn btn-wide" :class="{ 'btn-primary': !disabled }" :disabled="disabled">
            <slot></slot>
        </button>
    </div>
</template>

<script>
import { isEmpty, some } from 'lodash'
import { mapState } from 'vuex';

export default {
    name: 'question-selector-submitter',
    data: () => ({
        opened: false,
        selected: [],
        isEmpty,
    }),

    watch: {
        selected ()
        {
            this.$store.dispatch('SET_SELECTED_ANSWERS_FOR_SECTION', [
                this.sectionNumber,
                this.selected,
            ]);
        },
    },

    computed: {
        getIconClass ()
        {
            const out = ['glyphicon']
            if (this.opened)
            {
                out.push('glyphicon-chevron-down')
            }
            else
            {
                out.push('glyphicon-chevron-right')
            }
            return out
        },

        disabled ()
        {
            if (this.exportBuildings)
            {
                if (this.selectedRegions.counties.length === 1)
                {
                    return false
                }
                return true
            }
            if (!this.allProvince && isEmpty(this.selectedRegions.regions))
            {
                return true
            }
            const hasSomeAnswer = some(this.selectedAnswers, section => !isEmpty(section))
            return !hasSomeAnswer
        },

        ...mapState({
            $allProvince: state => JSON.stringify(state.allProvince),
            $regions: state => JSON.stringify(state.selectedRegions.regions),
            $counties: state => JSON.stringify(state.selectedRegions.counties),
            $exportBuildings: state => JSON.stringify(state.exportBuildings),
            $s1: state => JSON.stringify(state.selectedAnswers.s1),
            $s2: state => JSON.stringify(state.selectedAnswers.s2),
            $s3: state => JSON.stringify(state.selectedAnswers.s3),
            $s4: state => JSON.stringify(state.selectedAnswers.s4),
            $s5: state => JSON.stringify(state.selectedAnswers.s5),
            $s6: state => JSON.stringify(state.selectedAnswers.s6),
            $s7: state => JSON.stringify(state.selectedAnswers.s7),
            $s8: state => JSON.stringify(state.selectedAnswers.s8),
            $s9: state => JSON.stringify(state.selectedAnswers.s9),

            allProvince: state => state.allProvince,
            selectedRegions: state => state.selectedRegions,
            exportBuildings: state => state.exportBuildings,
            selectedAnswers: state => state.selectedAnswers,
        }),
    },

    methods: {
        toggleOpened ()
        {
            this.opened = !this.opened
        },
    },

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/question-selector-submitter.vue